import React, { FC } from 'react';
import config from '../../appConfig';

const AccessRestricted: FC = () => {
  const appgalleryUrl = `${config.universeFrontendUrl}/appgallery`;
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        zIndex: 9999,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '600px' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Access Denied</h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          You currently do not have permission to access this application.
        </p>
        <p style={{ fontSize: '1rem', color: '#666' }}>
          If you believe this is a mistake or need access, please contact the administrator. Or you can visit{' '}
          <a href={appgalleryUrl} style={{ color: '#007bff', textDecoration: 'none' }}>
            App Gallery
          </a>{' '}
          to explore our products.
        </p>
      </div>
    </div>
  );
};

export default AccessRestricted;
